import type { WithActiveBranchId } from '@app/api/shared';

export enum SocialIntegrationsEndpoints {
  GetIntegrationAuthState = 'GetIntegrationAuthState',
  RestartIntegration = 'RestartIntegration',
  AddIntegration = 'AddIntegration',
  TestIntegration1C = 'TestIntegration1C',
  AddIntegration1C = 'AddIntegration1C',
  DeleteIntegration1C = 'DeleteIntegration1C',
  GetIntegration1CById = 'GetIntegration1CById',
  UpdateIntegration1C = 'UpdateIntegration1C',
  UpdateIntegration1COptions = 'UpdateIntegration1COptions',
  AddIntegrationInOneStep = 'AddIntegrationInOneStep',
  RefreshIntegrationAuthData = 'RefreshIntegrationAuthData',
  RequestWhatsAppPairingCode = 'RequestWhatsAppPairingCode',
  EditSocialIntegration = 'EditSocialIntegration',
  EditOneStepSocialIntegration = 'EditOneStepSocialIntegration',
  SendMessageToClient = 'SendMessageToClient',
  SendMessageToClientAgain = 'SendMessageToClientAgain',
  EditMessage = 'EditMessage',
  SetReaction = 'SetReaction',
  DeleteMessage = 'DeleteMessage',
  DeleteIntegration = 'DeleteIntegration',
  GetSocialIntegrations = 'GetSocialIntegrations',
  GetSocialIntegrationsForSystem = 'GetSocialIntegrationsForSystem',
  GetActiveChannels = 'GetActiveChannels',
  GetActiveChannelsWithSender = 'GetActiveChannelsWithSender',
  GetSocialIntegrationById = 'GetSocialIntegrationById',
  UpdateSocialIntegrationEmailHandler = 'UpdateSocialIntegrationEmailHandler',
  GetUserSocialIntegrations = 'GetUserSocialIntegrations',
  ListByType = 'ListByType',
  GetSocialIntegrationOperators = 'GetSocialIntegrationOperators',
  SetSocialIntegrationOperators = 'SetSocialIntegrationOperators',
  GetSocialIntegrationsStatus = 'GetSocialIntegrationsStatus',
  GetSmsServiceStatistics = 'GetSmsServiceStatistics',
  CreateOrUpdateYookassaIntegration = 'CreateOrUpdateYookassaIntegration',
  DeleteYookassaIntegration = 'DeleteYookassaIntegration',
  GetYookassaGetCodeUrl = 'GetYookassaGetCodeUrl',
  GetYookassaIntegration = 'GetYookassaIntegration',
  GetPaymentMethods = 'GetPaymentMethods',
  GetInstagramPosts = 'GetInstagramPosts',
}

export type HistoryUploadPeriod = 1 | 2 | 3 | 4;

export type YookassaTaxSystemCode = 1 | 2 | 3 | 4 | 5 | 6;

export type YookassaVatCode = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface ModelSocialIntegrationCreate {
  Name: string | null;
  SalesFunnelId: number;
  SalesFunnelStageId: number;
  HistoryUploadPeriod?: HistoryUploadPeriod;
}

export interface ModelOneStepIntegrationCreate {
  Name: string | null;
  SalesFunnelId: number;
  SalesFunnelStageId: number;
  HistoryUploadPeriod?: HistoryUploadPeriod;
  Token?: string;
}

export interface ModelSocialIntegrationEdit {
  IntegrationId: number;
  Name: string | null;
  SalesFunnelId: number | null;
  SalesFunnelStageId: number | null;
  ParseUsingNeural: boolean;
}

export interface ModelOneStepSocialIntegrationEdit {
  IntegrationId: number;
  Name: string | null;
  SalesFunnelId: number | null;
  SalesFunnelStageId: number | null;
  ParseUsingNeural: boolean;
  Token?: string;
}

export interface ModelIntegration1CWarehouse {
  Guid1C: string | null;
  WarehouseName: string | null;
  IsSeleted: boolean;
}

export interface Model1cWarehouseIntegration {
  Id: number;
  Name: string | null;
  Server: string | null;
  Username: string | null;
  Password: string | null;
  Warehouses: ModelIntegration1CWarehouse[] | null;
}

export interface ModelAddIntegrationResponse {
  IntegrationId: number;
  QR: string | null;
  OAuthUrl: string | null;
  InstanceToken: string | null;
}

export interface ModelDestination {
  Phone: string | null;
  ClientId: number;
  LeadId: number | null;
}

export interface ClientAttachmentDto {
  Description: string | null;
  FileName: string | null;
  FileSize: number;
  Data: string | null;
}

export interface ModelSendMessage {
  IntegrationId: number;
  Destination: ModelDestination;
  Message: string | null;
  Attachments: ClientAttachmentDto[] | null;
  IsSendout: boolean;
  AiMessageTraceId?: string | null;
  ClientRequestId?: string | null;
}

export interface ModelEditMessage {
  IntegrationId: number;
  ClientMessageId: number;
  Message: string | null;
}

export interface ModelReactToMessage {
  IntegrationId: number;
  ClientMessageId: number;
  Emoji: string | null;
}

export interface ModelDeleteMessage {
  IntegrationId: number;
  ClientMessageId: number;
}

export interface SocialModelItem {
  Id: number;
  IdS: string | null;
  Name: string | null;
}

export interface SocialIntegrationModelItem {
  Id: number;
  IdS: string | null;
  Name: string | null;
  BranchId: number | null;
  BranchName: string | null;
  SocialType: string | null;
}

export interface ModelSocialIntegration {
  Id: number;
  BranchId: number;
  Branch: string | null;
  TimeCreated: string;
  CreateUserId: number;
  CreateUser: string | null;
  SocialType: string | null;
  OAuthUrl: string | null;
  AccountLogin: string | null;
  AccountName: string | null;
  SocialIntegrationName: string | null;
  Token: string | null;
  Status: string | null;
  SubStatus: string | null;
  LastStatusUpdate: string;
  ErrorMessage: string | null;
  IsDeleted: boolean;
  AccountPhoto: string | null;
  Password: string | null;
  Server: string | null;
  Port: number | null;
  IsSsl: boolean;
  SalesFunnelId: number | null;
  SalesFunnel: string | null;
  SalesFunnelStageId: number | null;
  SalesFunnelStage: string | null;
  ParseUsingNeural: boolean;
  SocialTypeUserFriendly: string | null;
}

// UpdateSocialIntegrationEmailHandler создаёт email-интеграцию на основе
// только этих полей, а не полной модели — остальные поля ModelSocialIntegration
// присутствуют в data лишь при редактировании уже существующей интеграции.
export type IntegrationToUpdate = Partial<ModelSocialIntegration> &
  Pick<
    ModelSocialIntegration,
    | 'SocialIntegrationName'
    | 'AccountLogin'
    | 'Password'
    | 'Server'
    | 'IsSsl'
    | 'Port'
    | 'SalesFunnelId'
    | 'SalesFunnelStageId'
  >;

export interface DtoOperator {
  Id: number;
  NameLast: string | null;
  NameFirst: string | null;
  IsSelected: boolean;
}

export interface DtoIntegrationOperators {
  IntegrationId: number;
  OperatorIds: number[] | null;
}

export interface ModelSocialIntegrationError {
  IntegrationId: number;
  BranchId: number;
  BranchName: string | null;
  SocialType: string | null;
  IntegrationName: string | null;
  Status: string | null;
  SubStatus: string | null;
  CanUserOpen: boolean;
}

export interface ModelSocialIntegrationsStatus {
  Timestamp: string;
  DatabaseId: string | null;
  ForUserId: number;
  HasErrors: boolean;
  CountErrors: number;
  ErrorIntegrations: ModelSocialIntegrationError[] | null;
}

export interface AddYookassaDto {
  Id: number | null;
  Code: string | null;
  LegalEntityId: number;
  BranchesIds: number[];
  IntegrationName: string;
  UseEmail: boolean;
  TaxSystemCode: YookassaTaxSystemCode;
  VatCode: YookassaVatCode;
}

export interface YookassaGetCodeUrlResponseDto {
  Url: string | null;
}

export interface YookassaIntegrationDto {
  LegalEntityId: number | null;
  BranchesIds: number[] | null;
  PaymentMethod: string | null;
  IntegrationName: string | null;
  UseEmail: boolean;
  TaxSystemCode: YookassaTaxSystemCode;
  VatCode: YookassaVatCode;
}

export interface ModelPaymentMethod {
  Name: string | null;
  Code: string | null;
  PaymentTerm: string | null;
  Holding: string | null;
  RegistryCode: string | null;
  Return: boolean;
  AutoPayments: boolean;
  IsDefault: boolean;
}

export interface ModelIntegrationId {
  IntegrationId: number;
}

export interface ModelSmsServiceStatsCounters {
  SubmittedToModem: number;
  DeliveryConfirmed: number;
  Failed: number;
  Leased: number;
  Accepted: number;
}

export interface ModelSmsServiceSimStatistics
  extends ModelSmsServiceStatsCounters {
  SimId: string | null;
  SlotIndex: number | null;
  SenderPhone: string | null;
  CarrierName: string | null;
  IsActive: boolean | null;
}

export interface ModelSmsServiceDeviceStatistics
  extends ModelSmsServiceStatsCounters {
  DeviceId: string | null;
  DisplayName: string | null;
  Status: string | null;
  LastSeenAt: string | null;
  Sims: ModelSmsServiceSimStatistics[] | null;
}

export interface ModelSmsServiceStatisticsTotals
  extends ModelSmsServiceStatsCounters {
  LeaseExpired: number;
  Expired: number;
}

export interface ModelSmsServiceDevicesStatistics {
  From: string | null;
  To: string | null;
  Totals: ModelSmsServiceStatisticsTotals;
  Devices: ModelSmsServiceDeviceStatistics[] | null;
}

export type RestartIntegrationRequest = WithActiveBranchId<{
  integrationId: number;
}>;
export type AddIntegrationRequest = WithActiveBranchId<{
  socialType: string;
  data: ModelSocialIntegrationCreate;
}>;
export type TestIntegration1CRequest = WithActiveBranchId<{
  data: Model1cWarehouseIntegration;
}>;
export type AddIntegration1CRequest = WithActiveBranchId<{
  data: Model1cWarehouseIntegration;
}>;
export type DeleteIntegration1CRequest = WithActiveBranchId<{
  data: ModelIntegrationId;
}>;
export type GetIntegration1CByIdRequest = WithActiveBranchId<{
  integrationId: number;
}>;
export type UpdateIntegration1CRequest = WithActiveBranchId<{
  data: Model1cWarehouseIntegration;
}>;
export type UpdateIntegration1COptionsRequest = WithActiveBranchId<{
  data: Model1cWarehouseIntegration;
}>;
export type AddIntegrationInOneStepRequest = WithActiveBranchId<{
  socialType: string;
  data: ModelOneStepIntegrationCreate;
}>;
export type GetIntegrationAuthStateRequest = WithActiveBranchId<{
  integrationId: number;
}>;
export type RefreshIntegrationAuthDataRequest = WithActiveBranchId<{
  integrationId: number;
}>;
export type EditSocialIntegrationRequest = WithActiveBranchId<{
  data: ModelSocialIntegrationEdit;
}>;
export type EditOneStepSocialIntegrationRequest = WithActiveBranchId<{
  data: ModelOneStepSocialIntegrationEdit;
}>;
export type SendMessageToClientRequest = WithActiveBranchId<{
  data: ModelSendMessage;
  // Лог-заголовки (HeaderUserId/HeaderDatabase) — по ним на бэке разбирают
  // инциденты отправки, паритет с v2-мутацией в
  // services/rtkQuery/SocialIntegrations/api.ts.
  logs?: {
    isLogged: boolean;
    userId: number | null;
    database: string | null;
  };
}>;
export type SendMessageToClientAgainRequest = WithActiveBranchId<{
  integrationId: number;
  clientMessageId: number;
}>;
export type EditMessageRequest = WithActiveBranchId<{
  data: ModelEditMessage;
}>;
export type SetReactionRequest = WithActiveBranchId<{
  data: ModelReactToMessage;
}>;
export type DeleteMessageRequest = WithActiveBranchId<{
  data: ModelDeleteMessage;
}>;
export type DeleteIntegrationRequest = WithActiveBranchId<{
  integrationId: number;
}>;
export type GetSocialIntegrationsRequest = WithActiveBranchId;
export type GetSocialIntegrationsForSystemRequest = WithActiveBranchId<{
  includeDeleted: boolean;
  leadId: number;
  lastActiveChannel: boolean;
}>;
export type GetActiveChannelsRequest = WithActiveBranchId;
export type GetActiveChannelsWithSenderRequest = WithActiveBranchId;
export type GetSocialIntegrationByIdRequest = WithActiveBranchId<{
  integrationId: number;
}>;
export type UpdateSocialIntegrationEmailHandlerRequest = WithActiveBranchId<{
  data: IntegrationToUpdate;
}>;
export type GetUserSocialIntegrationsRequest = WithActiveBranchId;
export type ListByTypeRequest = WithActiveBranchId<{
  socialType: string;
}>;
export type GetSocialIntegrationOperatorsRequest = WithActiveBranchId<{
  integrationId: number;
}>;
export type SetSocialIntegrationOperatorsRequest = WithActiveBranchId<{
  data: DtoIntegrationOperators;
}>;
export type GetSocialIntegrationsStatusRequest = WithActiveBranchId;
export type CreateOrUpdateYookassaIntegrationRequest = WithActiveBranchId<{
  data: AddYookassaDto;
}>;
export type DeleteYookassaIntegrationRequest = WithActiveBranchId<{
  integrationId: number;
}>;
export type GetYookassaGetCodeUrlRequest = WithActiveBranchId;
export type GetYookassaIntegrationRequest = WithActiveBranchId<{
  integrationId: number;
}>;
export type GetPaymentMethodsRequest = WithActiveBranchId<{
  paymentAccountId: number;
}>;
// Публикации Instagram для выбора в роботе «Сообщение по ключевым словам»
// (task/11643, beauty-crm @06b53580, договор техлида от 24.10.2026).
// Регистр — PascalCase, как у остальных ответов CRM (`PropertyNamingPolicy =
// null`). Время — UTC с Z. Ошибка приходит в ApiResult.ErrorMessage, пустой
// Items при успехе — «публикаций нет».
export type InstagramPostType = 'reels' | 'carousel' | 'single';

export interface InstagramPostDto {
  InstagramId: string;
  // Рилс отличается только по этому полю: у рилса MediaType = VIDEO.
  Type: InstagramPostType;
  MediaType: string | null;
  PreviewUrl: string | null;
  Caption: string | null;
  Permalink: string;
  CommentsCount: number;
  PublishedAt: string | null;
}

export interface InstagramPostsPageDto {
  Items: InstagramPostDto[];
  Total: number;
  HasMore: boolean;
  // Когда шлюз в последний раз начал обход публикаций аккаунта.
  PostsRefreshedAt: string | null;
}

export type GetInstagramPostsRequest = WithActiveBranchId<{
  integrationId: number;
  // 1..50: больше 50 ручка урезает, без значения берёт 24.
  limit: number;
  offset: number;
}>;
export type GetSmsServiceStatisticsRequest = WithActiveBranchId<{
  integrationId: number;
  from?: string;
  to?: string;
}>;

export type RestartIntegrationResponse = void;
export type AddIntegrationResponse = ModelAddIntegrationResponse;
export type TestIntegration1CResponse = Model1cWarehouseIntegration;
export type AddIntegration1CResponse = ModelSocialIntegration;
export type DeleteIntegration1CResponse = void;
export type GetIntegration1CByIdResponse = Model1cWarehouseIntegration;
export type UpdateIntegration1CResponse = ModelSocialIntegration;
export type UpdateIntegration1COptionsResponse = ModelSocialIntegration;
export type AddIntegrationInOneStepResponse = ModelAddIntegrationResponse;
export type GetIntegrationAuthStateResponse = {
  Status: string;
  SubStatus: string | null;
};
/**
 * Бэкенд отдаёт данные авторизации только пока интеграция в статусе
 * «Подключается»; в остальных случаях — включая успешное подключение — приходит
 * null. Тип был объявлен ненулевым, из-за чего окно оставляло на экране прежний
 * QR после успешного входа (issue/11029).
 */
export type RefreshIntegrationAuthDataResponse =
  ModelAddIntegrationResponse | null;

/** Код сопряжения WhatsApp — вход по номеру телефона вместо QR (task/10855) */
export interface ModelWhatsAppPairingCode {
  Code: string;
}

export interface ModelWhatsAppPairingCodeRequest {
  /** Полный номер телефона аккаунта WhatsApp */
  Phone: string;
}

export type RequestWhatsAppPairingCodeRequest = WithActiveBranchId<{
  integrationId: number;
  data: ModelWhatsAppPairingCodeRequest;
}>;
export type RequestWhatsAppPairingCodeResponse = ModelWhatsAppPairingCode;
export type EditSocialIntegrationResponse = ModelSocialIntegration;
export type EditOneStepSocialIntegrationResponse = ModelSocialIntegration;
export type SendMessageToClientResponse = void;
export type SendMessageToClientAgainResponse = void;
export type EditMessageResponse = void;
export type SetReactionResponse = void;
export type DeleteMessageResponse = void;
export type DeleteIntegrationResponse = void;
export type GetSocialIntegrationsResponse = ModelSocialIntegration[];
export type GetSocialIntegrationsForSystemResponse = ModelSocialIntegration[];
export type GetActiveChannelsResponse = SocialModelItem[];
export type GetActiveChannelsWithSenderResponse = SocialIntegrationModelItem[];
export type GetSocialIntegrationByIdResponse = ModelSocialIntegration;
export type UpdateSocialIntegrationEmailHandlerResponse =
  ModelSocialIntegration;
export type GetUserSocialIntegrationsResponse = SocialModelItem[];
export type ListByTypeResponse = Record<string, string>;
export type GetSocialIntegrationOperatorsResponse = DtoOperator[];
export type SetSocialIntegrationOperatorsResponse = void;
export type GetSocialIntegrationsStatusResponse = ModelSocialIntegrationsStatus;
export type CreateOrUpdateYookassaIntegrationResponse = void;
export type DeleteYookassaIntegrationResponse = void;
export type GetYookassaGetCodeUrlResponse = YookassaGetCodeUrlResponseDto;
export type GetYookassaIntegrationResponse = YookassaIntegrationDto;
export type GetPaymentMethodsResponse = ModelPaymentMethod[];
export type GetInstagramPostsResponse = InstagramPostsPageDto;
export type GetSmsServiceStatisticsResponse = ModelSmsServiceDevicesStatistics;
